import { createMuiTheme } from '@material-ui/core/styles'
import { blue, indigo } from '@material-ui/core/colors'

export const createAppTheme = darkMode => createMuiTheme({
  palette: {
    type: darkMode ? "dark" : "light",
    secondary: {
      main: darkMode ? blue[300] : blue[900]
    },
    primary: {
      main: darkMode ? indigo[200] : indigo[700]
    }
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '"Lato"',
      'sans-serif'
    ].join(',')
  }
});

export const Theme = createAppTheme(false);
